import { Fund, Hierarchy, LegalJurisdiction } from '~/types';

export type HierarchyPath =
  | {
      jurisdiction: LegalJurisdiction;
      fund: Fund;
    }
  | {
      jurisdiction?: LegalJurisdiction;
      fund: undefined;
    };
export type GetHierarchyPathArgs = {
  hierarchy: Hierarchy[];
  level: 'jurisdiction' | 'fund';
  jurisdictionKey?: string;
  fundId?: string;
};
export const getHierarchyPath = ({
  hierarchy,
  jurisdictionKey,
  fundId,
  level,
}: GetHierarchyPathArgs): HierarchyPath | undefined => {
  if (level === 'jurisdiction') {
    return {
      jurisdiction: hierarchy.find(
        (h) => h.legalJurisdiction.jurisdiction === jurisdictionKey,
      )?.legalJurisdiction,
      fund: undefined,
    };
  } else {
    let response: HierarchyPath | undefined;
    hierarchy.forEach((j) => {
      const fund = j.funds.find((f) => f.fundId === fundId);
      if (fund) {
        response = {
          jurisdiction: j.legalJurisdiction,
          fund: fund,
        };
      }
    });
    return response;
  }
};
